import styled from 'styled-components';

export const Container = styled.div`
  .__react_component_tooltip {
    padding: 0 21px;
  }
`;

export default { Container };
